import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d2cb382"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "revico-community-talk-details-new-arrival-badge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.isNew)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString($props.newArrivalBadgeText), 1 /* TEXT */))
    : _createCommentVNode("v-if", true)
}